<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>
 
    </nav> -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">PARTS</h2>
                </div>

                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-2" style="text-align: left;padding-right: 0px;max-width: 15%;margin-right: -35px;">
                            <label>Part Number </label><span style="color: red;">*</span><br />
                            <input type="text" placeholder="Prefix" id="prefix" [(ngModel)]="prefix"
                                class="box-input" />
                        </div>
                        <div class="col-2"
                            style="text-align: left;padding-top: 8px;padding-left: 0px;padding-right: 0px;max-width: 15%;margin-left: -50px;margin-right: -30px;">
                            <label></label><br />
                            <input type="text" placeholder="Base" id="Base" [(ngModel)]="Base" class="box-input" />
                        </div>
                        <div class="col-2"
                            style="text-align: left;padding-top: 8px;padding-left: 0px;padding-right: 0px;margin-left: -80px;">
                            <label></label><br />
                            <input type="text" placeholder="Suffix" id="suffix" [(ngModel)]="suffix"
                                class="box-input" />
                        </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="col-md-3" style="max-width: 20% !important;">
                            <label>Effective Date</label><span style="color: red;">*</span> <br />
                            <input type="date" id="EffectiveDate" [(ngModel)]="EffectiveDate" class="txt-input" />
                        </div>
                        <div class="col-md-2">
                            <label></label> <br />
                            <button class="bttn-save" id="myBtn" (click)="open(content)">View History</button>
                        </div>
                        <div class="col-md-3">
                            <label></label> <br />
                            <span [hidden]="isShownError1" style="color: red;">{{ErrorMsg}}</span>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-4" style="padding-bottom: 20px;">
                            <label>Part Name </label><br />
                            <input type="text" id="PartName" [(ngModel)]="PartName" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Short Description</label><span style="color: red;">*</span><br />
                            <input type="text" id="ShortDesc" [(ngModel)]="ShortDesc" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-8" style="text-align: left;">
                            <label>Long Description </label><span style="color: red;">*</span><br />
                            <textarea rows="4" cols="100" id="LongDesc" [(ngModel)]="LongDesc"
                                class="txt-input"></textarea>
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-2" style="text-align: left;">
                            <label>HS Code</label><span style="color: red;">*</span><br />
                            <input type="text" id="HSCOde" [(ngModel)]="HSCOde" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>COO</label><span style="color: red;">*</span><br />
                            <input type="text" id="Coo" [(ngModel)]="Coo" class="txt-input" list="contryname" (blur)="Checkcoo($event)"/>
                            <datalist id="contryname">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cnt of countrys" value={{cnt.countryname}}>{{cnt.countryname}}
                                </option>
                            </datalist>
                        </div>
                        <div class="col-md-4" style="text-align: left;">
                            <label>Supplier Name</label><span style="color: red;">*</span><br />
                            <input type="text" id="SupName" [(ngModel)]="SupName" class="txt-input" />
                        </div>
                        <!-- <div class="col-md-2" style="text-align: left;">
                            <label>Name</label><br />
                            <input type="text" id="Name" [(ngModel)]="Name" class="txt-input" />
                        </div> -->
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Address 1</label><br />
                            <input type="text" id="Address1" [(ngModel)]="Address1" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Address 2</label><br />
                            <input type="text" id="Address2" [(ngModel)]="Address2" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-2" style="text-align: left;">
                            <label>City</label><br />
                            <input type="text" id="City" [(ngModel)]="City" class="txt-input" />
                        </div>
                        <div class="col-lg-2" style="text-align: left;">
                            <label>State</label><br />
                            <input type="text" id="State" [(ngModel)]="State" class="txt-input" />
                        </div>
                        <div class="col-lg-2" style="text-align: left;">
                            <label>Country</label><br />
                            <input type="text" id="country" [(ngModel)]="country" class="txt-input" list="contryname" (blur)="Checkcnty($event)"/>
                            <datalist id="contryname">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cnt of countrys" value={{cnt.countryname}}>{{cnt.countryname}}
                                </option>
                            </datalist>
                        </div>
                        <div class="col-lg-2" style="text-align: left;">
                            <label>Zip</label><br />
                            <input type="text" id="Zip" [(ngModel)]="Zip" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3" style="text-align: left;">
                            <label>Contact Name</label><br />
                            <input type="text" id="ContactName" [(ngModel)]="ContactName" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>Title</label><br />
                            <input type="text" id="Title" [(ngModel)]="Title" class="txt-input" />
                        </div>
                        <div class="col-md-3" style="text-align: left;">
                            <label>Phone</label><br />
                            <input type="text" id="Phone" [(ngModel)]="Phone" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Email</label><br />
                            <input type="text" id="Email" [(ngModel)]="Email" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>VAT/GST</label><br />
                            <input type="text" id="vat" [(ngModel)]="vat" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-2" style="text-align: left;">
                            <label>Currency</label><span style="color: red;">*</span><br />
                            <input type="text" id="Currency" [(ngModel)]="Currency" class="txt-input" list="curency" (blur)="Checkcrncy($event)"/>
                            <datalist id="curency">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cny of currency" value={{cny.currencycode}}>{{cny.currencycode}}
                                </option>
                            </datalist>
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>Unit Price</label><span style="color: red;">*</span><br />
                            <input type="text" id="UnitPrice" [(ngModel)]="UnitPrice" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>UOM</label><span style="color: red;">*</span><br />
                            <input type="text" id="UOM" [(ngModel)]="UOM" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Restrictions</label><br />
                            <select name="Restrictions" id="Restrictions" [(ngModel)]="Restrictions" class="txt-input">
                                <option value="0" disabled>Select</option>
                                <option value="1">BIS</option>
                                <option value="2">BIS Required, Excemption for exported vehichle</option>
                                <option value="3">WPC Restricted</option>
                            </select>
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>C Notn</label><br />
                            <input type="text" id="Cnotn" [(ngModel)]="Cnotn" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>C Notn Sl No</label><br />
                            <input type="text" id="CNtnSiNo" [(ngModel)]="CNtnSiNo" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>CusDty Rt</label><br />
                            <input type="text" id="CusDtyRt" [(ngModel)]="CusDtyRt" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>AntiDm Notn</label><br />
                            <input type="text" id="AntiDmNotn" [(ngModel)]="AntiDmNotn" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>AntiDm Notn Sl No</label><br />
                            <input type="text" id="AntiDmSiNo" [(ngModel)]="AntiDmSiNo" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>AntiDm UnitPrice</label><br />
                            <input type="text" id="AntiUnitPrice" [(ngModel)]="AntiUnitPrice" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-2" style="text-align: left;">
                            <label>E Notn</label><br />
                            <input type="text" id="ENotn" [(ngModel)]="ENotn" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>E Notn Sl No</label><br />
                            <input type="text" id="ENotnSiNo" [(ngModel)]="ENotnSiNo" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>ExcDty Rt</label><br />
                            <input type="text" id="ExcDtyRt" [(ngModel)]="ExcDtyRt" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>SpExDty Rt</label><br />
                            <input type="text" id="SpExDtyRt" [(ngModel)]="SpExDtyRt" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>HCVD Rt</label><br />
                            <input type="text" id="HCVDRt" [(ngModel)]="HCVDRt" class="txt-input" />
                        </div>

                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-2" style="text-align: left;">
                            <label>ECC Rt</label><br />
                            <input type="text" id="ECCRt" [(ngModel)]="ECCRt" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>SHECC Rt</label><br />
                            <input type="text" id="SHECCRt" [(ngModel)]="SHECCRt" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>CEC Rt</label><br />
                            <input type="text" id="CECRt" [(ngModel)]="CECRt" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>CSHEC Rt</label><br />
                            <input type="text" id="CSHECRt" [(ngModel)]="CSHECRt" class="txt-input" />
                        </div>
                        <div class="col-md-2" style="text-align: left;">
                            <label>SWS Rt</label><br />
                            <input type="text" id="SWSRt" [(ngModel)]="SWSRt" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>IGST Notn</label><span style="color: red;">*</span><br />
                            <input type="text" id="IGSTNOtn" [(ngModel)]="IGSTNOtn" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>IGST Notn Sl No</label><br />
                            <input type="text" id="IGSTtnSiNo" [(ngModel)]="IGSTtnSiNo" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>IGST Rt</label><span style="color: red;">*</span><br />
                            <input type="text" id="IGSTRt" [(ngModel)]="IGSTRt" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>GST Notn</label><span style="color: red;">*</span><br />
                            <input type="text" id="GSTNOtn" [(ngModel)]="GSTNOtn" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>GST Notn Sl No</label><br />
                            <input type="text" id="GSTtnSiNo" [(ngModel)]="GSTtnSiNo" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>GST Rt</label><span style="color: red;">*</span><br />
                            <input type="text" id="GSTRt" [(ngModel)]="GSTRt" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-2" style="text-align: left;">
                            <label>Is FTA Part ?</label><br />
                            <input type="radio" id="FTAPortYes" name="FTAPort" />&nbsp;
                            <label for="Yes">Yes</label> &nbsp;&nbsp;
                            <input type="radio" id="FTAPortNo" name="FTAPort" />&nbsp;
                            <label for="No">No</label>
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>FTA Notn</label><br />
                            <input type="text" id="FTANotn" [(ngModel)]="FTANotn" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>FTA Sl No</label><br />
                            <input type="text" id="FTASiNo" [(ngModel)]="FTASiNo" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-2" style="text-align: left;">
                            <label>Is SIMS Part ?</label><br />
                            <input type="radio" id="SIMSPartYes" name="SimsPart" />&nbsp;
                            <label for="Yes">Yes</label> &nbsp;&nbsp;
                            <input type="radio" id="SIMSPartNo" name="SimsPart" />&nbsp;
                            <label for="No">No</label>
                        </div>
                        <div class="col-lg-6" style="text-align: left;">
                            <label>SIMS Remarks</label><br />
                            <input type="text" id="Sims" [(ngModel)]="Sims" class="txt-input" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6"></div>
                        <div class="col-lg-2" style="padding-top: 39px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-2" style="padding-top: 30px;">
                            <button class="bttn-save" (click)="SubmitParts()" [hidden]="isShownSaveBtn">SAVE</button>
                            <button class="bttn-Update" (click)="UpdateParts()"
                                [hidden]="isShownUpdateBtn">Update</button>
                        </div>
                        <div class="col-lg-2" style="padding-top: 30px;">
                            <button class="bttn-clear" (click)="ClearParts()">CLEAR</button>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>

                </div>
            </div>

            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:auto;">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-7"></div>
                                                    <div class="col-lg-5">
                                                        <div class="form-group">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="partno">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Part Number</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.partno}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="shortdesc">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Short Desc</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.shortdesc}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="hscode">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                HS Code</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.hscode}}
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="coo">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Country Of Origin</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.coo}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="unitPrice">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Unit Price</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.unitPrice}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="effectiveDate">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Start Date</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.effectiveDate}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="enddate">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                End Date</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.enddate}}
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditPart(element)" style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5,10,40, 50,75,100]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-lg-12">
                    <table style="width:100%" id="tblHeader" [hidden]="isShownExportTable">
                        <thead>
                            <tr>
                                <th>Part Number</th>                               
                                <th>Part Name</th>
                                <th>Hscode</th>
                                <th>Coo</th>
                                <th>Suppliername</th>
                                <th>Address1</th>
                                <th>Address2</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Country</th>
                                <th>Zip</th>
                                <th>Contactname</th>
                                <th>Title</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Vat</th>
                                <th>Currency</th>
                                <th>UnitPrice</th>
                                <th>Uom</th>
                                <th>Restrictions</th>
                                <th>Cnotn</th>
                                <th>CnotnSiNo</th>
                                <th>CusDtyRt</th>
                                <th>AntdmNotn</th>
                                <th>AntidmNotSiNo</th>
                                <th>AntidmUnitPrice</th>
                                <th>Enotn</th>                                
                                <th>EnotnSiNo</th>
                                <th>ExcDtyRt</th>
                                <th>SpexDytRt</th>
                                <th>Hcvdrt</th>
                                <th>Eccrt</th>
                                <th>Sheccrt</th>
                                <th>Cecrt</th>
                                <th>Cshecrt</th>
                                <th>Swsrt</th>
                                <th>Igstnotn</th>
                                <th>IgstnotnSno</th>
                                <th>Igstrt</th>
                                <th>Gstcnotn</th>
                                <th>GstcnotnSino</th>
                                <th>Gstcrt</th>
                                <th>Ftanotn</th>
                                <th>Ftasno</th>
                                <th>Simsremarks</th>
                                <th>Shortdesc</th>
                                <th>Longdesc</th>   
                                <th>EffectiveDate</th>   
                                <th>Enddate</th>   
                                <th>Status</th>   
                               </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let prtexp of PartsExport">
                                <td>{{prtexp.partno}}</td>
                                <td>{{prtexp.partName}}</td>
                                <td>{{prtexp.hscode}}</td>
                                <td>{{prtexp.coo}}</td>
                                <td>{{prtexp.suppliername}}</td>
                                <td>{{prtexp.address1}}</td>
                                <td>{{prtexp.address2}}</td>
                                <td>{{prtexp.city}}</td>
                                <td>{{prtexp.state}}</td>
                                <td>{{prtexp.country}}</td>
                                <td>{{prtexp.zip}}</td>
                                <td>{{prtexp.contactname}}</td>
                                <td>{{prtexp.title}}</td>
                                <td>{{prtexp.phone}}</td>
                                <td>{{prtexp.email}}</td>
                                <td>{{prtexp.vat}}</td>
                                <td>{{prtexp.currency}}</td>
                                <td>{{prtexp.unitPrice}}</td>
                                <td>{{prtexp.uom}}</td>
                                <td>{{prtexp.restrictions}}</td>
                                <td>{{prtexp.cnotn}}</td>
                                <td>{{prtexp.cnotnSiNo}}</td>
                                <td>{{prtexp.cusDtyRt}}</td>
                                <td>{{prtexp.antdmNotn}}</td>
                                <td>{{prtexp.antidmNotSiNo}}</td>
                                <td>{{prtexp.antidmUnitPrice}}</td>
                                <td>{{prtexp.enotn}}</td>
                                <td>{{prtexp.enotnSiNo}}</td>
                                <td>{{prtexp.excDtyRt}}</td>
                                <td>{{prtexp.spexDytRt}}</td>
                                <td>{{prtexp.hcvdrt}}</td>
                                <td>{{prtexp.eccrt}}</td>
                                <td>{{prtexp.sheccrt}}</td>
                                <td>{{prtexp.cecrt}}</td>
                                <td>{{prtexp.cshecrt}}</td>
                                <td>{{prtexp.swsrt}}</td>
                                <td>{{prtexp.igstnotn}}</td>
                                <td>{{prtexp.igstnotnSno}}</td>
                                <td>{{prtexp.igstrt}}</td>
                                <td>{{prtexp.gstcnotn}}</td>
                                <td>{{prtexp.gstcnotnSino}}</td>
                                <td>{{prtexp.gstcrt}}</td>
                                <td>{{prtexp.ftanotn}}</td>
                                <td>{{prtexp.ftasno}}</td>
                                <td>{{prtexp.simsremarks}}</td>
                                <td>{{prtexp.shortdesc}}</td>
                                <td>{{prtexp.longdesc}}</td>
                                <td>{{prtexp.effectivefrom}}</td>
                                <td>{{prtexp.enddate}}</td>
                                <td>{{prtexp.status}}</td>
                            </tr>
                        </tbody>                      
                    </table>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->

        </div>
    </div>
</div>


<!-----Modal Start------>
<ng-template #content let-modal style="width: fit-content !important;">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Parts History</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin">
                            <div class="card">
                                <div class="card-body" style="width:auto;">
                                    <div class="row">
                                        <div class="col-12 grid-margin">
                                            <div class="card">
                                                <div class="card-body" style="padding: 0;">
                                                    <!-- <div class="col-lg-12 form-inline"
                                                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                        <div class="col-lg-7"></div>
                                                        <div class="col-lg-5">
                                                            <div class="form-group">
                                                                <div class="input-group">                                                                   
                                                                    <input type="text" placeholder="Search"
                                                                        [(ngModel)]="searchText"
                                                                        (keyup)="applyFilter($event.target.value)"
                                                                        class="txt-Search"> <i
                                                                        class="fa fa-search fa-2x"
                                                                        style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                </div>
                                                                <button type="button" class="btn btn-sm ">
                                                                    <img src="../../assets/ExportPDF.png" />
                                                                </button>
                                                                <button type="button" class="btn  btn-sm">
                                                                    <img src="../../assets/ExportExcel.png"
                                                                        (click)="exportexcel()"
                                                                        style="cursor: pointer;" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div> -->


                                                    <div class="col-sm-12 mat-elevation-z8"
                                                        style="box-shadow: unset;padding: 0px ;">
                                                        <table mat-table [dataSource]="dataSource1" style="width: 100%;"
                                                            matSort #sort1="matSort">
                                                            <ng-container matColumnDef="sno">
                                                                <th mat-header-cell *matHeaderCellDef
                                                                    style="color: black !important;background-color: white">
                                                                    S.NO </th>
                                                                <td mat-cell *matCellDef="let item; let k = index">
                                                                    {{(k +1)  + (paginator1.pageIndex * paginator1.pageSize) }}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="partno">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Part Number</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.partno}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="shortdesc">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Short Desc</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.shortdesc}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="hscode">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    HS Code</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.hscode}}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="coo">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Country Of Origin</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.coo}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="unitPrice">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Unit Price</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.unitPrice}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="effectiveDate">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Start Date</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.effectiveDate}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="enddate">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    End Date</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.enddate}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="status">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Status</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="EditPart(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.status}}
                                                                </td>
                                                            </ng-container>
                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns1">
                                                            </tr>
                                                            <tr mat-row
                                                                *matRowDef="let row; columns: displayedColumns1;">
                                                            </tr>
                                                        </table>
                                                        <mat-paginator #paginator1="matPaginator"
                                                            [pageSizeOptions]="[5, 10,40, 50,75,100]"
                                                            showFirstLastButtons></mat-paginator>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4"></div>
                                        <div class="col-lg-4"></div>
                                        <div class="col-lg-4">
                                            <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <label for="dateOfBirth">Date of birth</label>
                <div class="input-group">
                    <input id="dateOfBirth" class="form-control" placeholder="yyyy-mm-dd"
                        name="dp" ngbDatepicker #dp="ngbDatepicker">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()"
                            type="button"></button>
                    </div>
                </div> -->
            </div>
        </form>
    </div>
    <!-- <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
    </div> -->
</ng-template>
<!--------Modal End-------->